var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "settingsNotifications" } }, [
    _c("div", { staticClass: "name" }, [_vm._v("Notification Settings")]),
    _vm._v(" "),
    _c("div", { staticClass: "context" }, [
      _vm._v(
        "\n    Manage your notifications with simplicity and ease. Select which notifications you would like enabled or disabled by tapping their respective checkboxes. By default, all notifications are enabled.\n  "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-content" }, [
      _c("div", { staticClass: "type" }, [_vm._v("Push Notifications")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "checkboxes" },
        [
          _c("v-checkbox", {
            staticClass: "checkbox",
            attrs: {
              "hide-details": "",
              label: "New Chat Message",
              color: "primary"
            },
            model: {
              value: _vm.notificationSettings.ticketComment.push,
              callback: function($$v) {
                _vm.$set(_vm.notificationSettings.ticketComment, "push", $$v)
              },
              expression: "notificationSettings.ticketComment.push"
            }
          }),
          _vm._v(" "),
          _c("v-checkbox", {
            staticClass: "checkbox",
            attrs: {
              "hide-details": "",
              label: "Ticket Status Change",
              color: "primary"
            },
            model: {
              value: _vm.notificationSettings.ticketStatusChanged.push,
              callback: function($$v) {
                _vm.$set(
                  _vm.notificationSettings.ticketStatusChanged,
                  "push",
                  $$v
                )
              },
              expression: "notificationSettings.ticketStatusChanged.push"
            }
          }),
          _vm._v(" "),
          _c("v-checkbox", {
            staticClass: "checkbox",
            attrs: {
              "hide-details": "",
              label: "New Ticket",
              color: "primary"
            },
            model: {
              value: _vm.notificationSettings.ticketCreation.push,
              callback: function($$v) {
                _vm.$set(_vm.notificationSettings.ticketCreation, "push", $$v)
              },
              expression: "notificationSettings.ticketCreation.push"
            }
          }),
          _vm._v(" "),
          _c("v-checkbox", {
            staticClass: "checkbox",
            attrs: {
              "hide-details": "",
              label: "Assignee Updates",
              color: "primary"
            },
            model: {
              value: _vm.notificationSettings.ticketAssigneeChanged.push,
              callback: function($$v) {
                _vm.$set(
                  _vm.notificationSettings.ticketAssigneeChanged,
                  "push",
                  $$v
                )
              },
              expression: "notificationSettings.ticketAssigneeChanged.push"
            }
          }),
          _vm._v(" "),
          _c("v-checkbox", {
            staticClass: "checkbox",
            attrs: {
              "hide-details": "",
              label: "Ticket Resolved",
              color: "primary"
            },
            model: {
              value: _vm.notificationSettings.ticketResolved.push,
              callback: function($$v) {
                _vm.$set(_vm.notificationSettings.ticketResolved, "push", $$v)
              },
              expression: "notificationSettings.ticketResolved.push"
            }
          }),
          _vm._v(" "),
          _vm.hasPropertyLevelAccess
            ? [
                _c("v-checkbox", {
                  staticClass: "checkbox",
                  attrs: {
                    "hide-details": "",
                    label: "New Ticket Note",
                    color: "primary"
                  },
                  model: {
                    value: _vm.notificationSettings.ticketNote.push,
                    callback: function($$v) {
                      _vm.$set(_vm.notificationSettings.ticketNote, "push", $$v)
                    },
                    expression: "notificationSettings.ticketNote.push"
                  }
                }),
                _vm._v(" "),
                _c("v-checkbox", {
                  staticClass: "checkbox",
                  attrs: {
                    "hide-details": "",
                    label: "Ticket Tags Change",
                    color: "primary"
                  },
                  model: {
                    value: _vm.notificationSettings.ticketTagsChanged.push,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.notificationSettings.ticketTagsChanged,
                        "push",
                        $$v
                      )
                    },
                    expression: "notificationSettings.ticketTagsChanged.push"
                  }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "type" }, [_vm._v("Email Notifications")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "checkboxes" },
        [
          _c("v-checkbox", {
            staticClass: "checkbox",
            attrs: {
              "hide-details": "",
              label: "New Chat Message",
              color: "primary"
            },
            model: {
              value: _vm.notificationSettings.ticketComment.email,
              callback: function($$v) {
                _vm.$set(_vm.notificationSettings.ticketComment, "email", $$v)
              },
              expression: "notificationSettings.ticketComment.email"
            }
          }),
          _vm._v(" "),
          _c("v-checkbox", {
            staticClass: "checkbox",
            attrs: {
              "hide-details": "",
              label: "Ticket Status Change",
              color: "primary"
            },
            model: {
              value: _vm.notificationSettings.ticketStatusChanged.email,
              callback: function($$v) {
                _vm.$set(
                  _vm.notificationSettings.ticketStatusChanged,
                  "email",
                  $$v
                )
              },
              expression: "notificationSettings.ticketStatusChanged.email"
            }
          }),
          _vm._v(" "),
          _c("v-checkbox", {
            staticClass: "checkbox",
            attrs: {
              "hide-details": "",
              label: "New Ticket",
              color: "primary"
            },
            model: {
              value: _vm.notificationSettings.ticketCreation.email,
              callback: function($$v) {
                _vm.$set(_vm.notificationSettings.ticketCreation, "email", $$v)
              },
              expression: "notificationSettings.ticketCreation.email"
            }
          }),
          _vm._v(" "),
          _c("v-checkbox", {
            staticClass: "checkbox",
            attrs: {
              "hide-details": "",
              label: "Assignee Updates",
              color: "primary"
            },
            model: {
              value: _vm.notificationSettings.ticketAssigneeChanged.email,
              callback: function($$v) {
                _vm.$set(
                  _vm.notificationSettings.ticketAssigneeChanged,
                  "email",
                  $$v
                )
              },
              expression: "notificationSettings.ticketAssigneeChanged.email"
            }
          }),
          _vm._v(" "),
          _c("v-checkbox", {
            staticClass: "checkbox",
            attrs: {
              "hide-details": "",
              label: "Ticket Resolved",
              color: "primary"
            },
            model: {
              value: _vm.notificationSettings.ticketResolved.email,
              callback: function($$v) {
                _vm.$set(_vm.notificationSettings.ticketResolved, "email", $$v)
              },
              expression: "notificationSettings.ticketResolved.email"
            }
          }),
          _vm._v(" "),
          _vm.hasPropertyLevelAccess
            ? [
                _c("v-checkbox", {
                  staticClass: "checkbox",
                  attrs: {
                    "hide-details": "",
                    label: "New Ticket Note",
                    color: "primary"
                  },
                  model: {
                    value: _vm.notificationSettings.ticketNote.email,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.notificationSettings.ticketNote,
                        "email",
                        $$v
                      )
                    },
                    expression: "notificationSettings.ticketNote.email"
                  }
                }),
                _vm._v(" "),
                _c("v-checkbox", {
                  staticClass: "checkbox",
                  attrs: {
                    "hide-details": "",
                    label: "Ticket Tags Change",
                    color: "primary"
                  },
                  model: {
                    value: _vm.notificationSettings.ticketTagsChanged.email,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.notificationSettings.ticketTagsChanged,
                        "email",
                        $$v
                      )
                    },
                    expression: "notificationSettings.ticketTagsChanged.email"
                  }
                }),
                _vm._v(" "),
                _c("v-checkbox", {
                  staticClass: "checkbox",
                  attrs: {
                    "hide-details": "",
                    label: "Daily Summary",
                    color: "primary"
                  },
                  model: {
                    value: _vm.notificationSettings.dailyEmail.email,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.notificationSettings.dailyEmail,
                        "email",
                        $$v
                      )
                    },
                    expression: "notificationSettings.dailyEmail.email"
                  }
                })
              ]
            : _vm._e()
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "buttons" },
      [
        _c(
          "v-btn",
          {
            staticClass: "button",
            attrs: { loading: _vm.lockout, color: "primary", flat: "" },
            on: {
              click: function($event) {
                _vm.save()
              }
            }
          },
          [_vm._v("Save")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "clear" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1da29f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1da29f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SettingsNotifications.vue
// module id = 581
// module chunks = 4